let address;

if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
  address = 'http://localhost:3000/';
} else {
  address = 'https://vicki.caiado.solutions/api/';
}

export { address };
